module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.3885/images/homepage/hero-personas/thumbnail-23.webp"